export default __webpack_public_path__ + "static/pudding_black_white_issue-a7c84d52fe75f4c69be7a67dcf5cc9bb.png";